import './AssociatedPackageList.scss';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Packages from '../../../../api/controllers/Packages/Packages';
import GoodsOut from '../../../../api/controllers/GoodsOut/GoodsOut';
import LoadAllModal from '../../../InProgressJob/subComponents/LoadAllModal/LoadAllModal';
import Modal from '../../../../common/Modal/Modal';
import ResetModal from '../../../InProgressJob/subComponents/ResetModal/ResetModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import GoodsIn from '../../../../api/controllers/GoodsIn/GoodsIn';
import TransshippingModal from '../../../InProgressOverview/subComponents/TransshippingModal/TransshippingModal';
import Button from '../../../../common/Button/Button';

// AssociatedPackageList Component
const AssociatedPackageList = ({
  job,
  hubId,
  bays,
  racks,
  setError,
  setLoading,
  assignedPackages,
  refreshPackages,
  movement,
  category,
  setDisplayAssignment,
  movementType,
  completed,
}) => {
  const [dangerousGoods, setDangerousGoods] = useState();
  const [associatedPackages, setAssociatedPackages] = useState();
  const [outstandingCollections, setOutstandingCollections] = useState();

  const [modalOpen, setModalOpen] = useState();

  const allPackages = [...(assignedPackages || []), ...(associatedPackages || [])];
  const expQuantity = completed
    ? movement?.assignments
        .filter(a => a?.job.id == assignedPackages[0]?.job?.id)
        .map(a => a?.quantity)
        .reduce((a, b) => a + b, 0)
    : allPackages.map(a => a?.quantity).reduce((a, b) => a + b, 0);

  const actQuantityItems = assignedPackages?.map(pkg => pkg?.quantity).reduce((a, b) => a + b, 0);
  const type =
    allPackages && allPackages[0]?.packageType?.shortName
      ? allPackages?.every(
          pkg => pkg?.packageType?.shortName == allPackages[0]?.packageType?.shortName,
        )
        ? allPackages[0]?.packageType?.shortName
        : 'pkg'
      : 'pkg';
  const expWeight = completed
    ? movement?.assignments
        .filter(a => a?.job.id == assignedPackages[0]?.job?.id)
        .map(a => a?.grossWeightKg)
        .reduce((a, b) => a + b, 0)
    : allPackages.map(a => a?.grossWeightKg).reduce((a, b) => a + b, 0);
  const actWeight = assignedPackages?.map(pkg => pkg?.grossWeightKg).reduce((a, b) => a + b, 0);
  const expVolume = completed
    ? movement?.assignments
        .filter(a => a?.job.id == assignedPackages[0]?.job?.id)
        .map(pkg => Number(pkg?.cubicMetres))
        .reduce((a, b) => a + b, 0)
        .toFixed(2)
    : allPackages
        ?.map(pkg => Number(pkg?.cubicMetres))
        .reduce((a, b) => a + b, 0)
        .toFixed(2);
  const actVolume = assignedPackages
    ?.map(pkg => Number(pkg?.cubicMetres))
    .reduce((a, b) => a + b, 0)
    .toFixed(2);

  const assignPackage = pkgId => {
    setLoading(true);
    GoodsOut.assign(category, movement.id, pkgId)
      .then(() => {
        getPackages();
        refreshPackages();
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const removePackage = pkgId => {
    setLoading(true);
    GoodsOut.remove(category, movement.id, pkgId)
      .then(() => {
        getPackages();
        refreshPackages();
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getPackages = () => {
    setLoading(true);
    const params = { hubId: hubId, jobId: job?.id, status: 'in_warehouse' };
    Packages.all(params)
      .then(response => {
        setAssociatedPackages(response.items);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getOutstandingCollections = () => {
    setLoading(true);
    const params = { hubId: hubId, category: 'domestic', jobId: job?.id, status: 'pending' };
    GoodsIn.all(params)
      .then(response => {
        setOutstandingCollections(response.items);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getModalTitle = () => {
    switch (modalOpen) {
      case 'transship':
        return `Transship Domestic Collection for ${outstandingCollections[0]?.assignments[0]?.job?.jobReference}`;
      default:
        return null;
    }
  };

  const getModalType = () => {
    switch (modalOpen) {
      case 'transship':
        return (
          <TransshippingModal
            category={category}
            movementId={movement?.id}
            setModalOpen={setModalOpen}
            collection={outstandingCollections[0]}
            refreshMovement={() => {
              getPackages();
              refreshPackages();
              getOutstandingCollections();
            }}
            dangerousGoods={dangerousGoods}
          />
        );
      case 'load_all':
        return (
          <LoadAllModal
            setModalOpen={setModalOpen}
            category={category}
            movement={movement}
            refreshPackages={() => {
              getPackages();
              refreshPackages();
            }}
            packages={associatedPackages}
          />
        );
      case 'reset':
        return (
          <ResetModal
            setModalOpen={setModalOpen}
            category={category}
            movement={movement}
            refreshPackages={() => {
              getPackages();
              refreshPackages();
            }}
            packages={assignedPackages}
          />
        );
    }
  };

  useEffect(() => {
    if (job) {
      getPackages();
      setDangerousGoods(job?.dangerousGoodsLines);
      if (movementType == 'exports') {
        getOutstandingCollections();
      }
    }
  }, [job, assignedPackages]);

  return (
    <>
      {assignedPackages && !completed && (
        <div
          className={`in_progress_movement_buttons bottom_border ${
            category == 'international' ? 'with_overview' : ''
          }`}
        >
          {category == 'international' && (
            <Button
              buttonType={'grey'}
              className="in_progress_movement_button grey overview"
              onClick={() => setDisplayAssignment(false)}
              label={
                <div className="overview_back">
                  <FontAwesomeIcon icon={faArrowLeft} />
                  Overview
                </div>
              }
            />
          )}
          <Button
            buttonType={'light_blue'}
            className="in_progress_movement_button light_blue load_all"
            onClick={() => setModalOpen('load_all')}
            label="Load all"
          />
          <Button
            buttonType={'orange'}
            className={`in_progress_movement_button orange reset_loading`}
            onClick={() => setModalOpen('reset')}
            label="Reset"
          />
        </div>
      )}
      <div className="packages_in_warehouse_container">
        <div className="packages_in_warehouse_title">
          {assignedPackages ? (
            <div className="title_grid">
              <div className="title">Loading Status</div>
              <div className="quantity">
                {actQuantityItems} / {expQuantity} {type}
              </div>
              <div className="weight">
                {actWeight} / {expWeight} kg
              </div>
              <div className="volume">
                {actVolume} / {expVolume} m³
              </div>
            </div>
          ) : (
            'Packages in Warehouse'
          )}
        </div>
        <div className="packages_in_warehouse_body">
          {assignedPackages &&
            assignedPackages?.map(pkg => {
              const packageBay = bays
                ?.concat([]?.concat.apply([], Object.values(racks)))
                ?.find(b => b?.id == pkg.bayId);

              return (
                <div className="package" key={pkg.id}>
                  <div className="package_details assigned">
                    <div className="col-1">
                      <div className="package_ref">{`${pkg.job?.jobReference}-${
                        pkg.packageNumber
                      } (Bay${
                        pkg?.bayId
                          ? ` ${packageBay?.bayType[0] || ''}${
                              packageBay?.bayNumber || ''
                            }`.toUpperCase()
                          : 'less'
                      })`}</div>
                      <div className="package_creation_method">
                        {pkg.creationMethod?.charAt(0)?.toUpperCase() +
                          pkg.creationMethod?.replaceAll('_', ' ').substring(1)?.toLowerCase()}
                      </div>
                    </div>
                    <div className="package_quantity">
                      {pkg.quantity} {pkg.job?.packageType?.shortName || 'pkg'}
                      {pkg.quantity > 1 ? 's' : ''}
                    </div>
                    <div className="package_weight">{pkg.grossWeightKg || '???'} kg</div>
                    <div className="package_volume">{pkg.cubicMetres || '0.00'} m³</div>
                    {assignedPackages && !completed && (
                      <div className="load_button_container">
                        <button className={`load_button red`} onClick={() => removePackage(pkg.id)}>
                          Undo
                        </button>
                      </div>
                    )}
                  </div>
                  <ul className="dangerous_goods_details">
                    {pkg.dangerousGoodsAssociations?.length > 0 ? (
                      pkg.dangerousGoodsAssociations?.map(dangerousGood => (
                        <li key={dangerousGood.id}>
                          {
                            dangerousGoods?.find(
                              good => good?.id == dangerousGood?.dangerousGoodsLineItemId,
                            )?.longText
                          }
                        </li>
                      ))
                    ) : (
                      <li>No Dangerous Goods present</li>
                    )}
                  </ul>
                </div>
              );
            })}
          {associatedPackages?.map(pkg => {
            const packageBay = bays
              ?.concat([]?.concat.apply([], Object.values(racks)))
              ?.find(b => b?.id == pkg.bayId);

            return (
              <div className="package" key={pkg.id}>
                <div className="package_details">
                  <div className="col-1">
                    <div className="package_ref">{`${pkg.job?.jobReference}-${
                      pkg.packageNumber
                    } (Bay${
                      pkg?.bayId
                        ? ` ${packageBay?.bayType[0] || ''}${
                            packageBay?.bayNumber || ''
                          }`.toUpperCase()
                        : 'less'
                    })`}</div>
                    {assignedPackages ? (
                      <div className="package_creation_method">
                        {pkg.creationMethod?.charAt(0)?.toUpperCase() +
                          pkg.creationMethod?.replaceAll('_', ' ').substring(1)?.toLowerCase()}
                      </div>
                    ) : (
                      <div className="package_dimensions">{`${
                        pkg.packageType?.name || 'Package'
                      } (${pkg.lengthCm || '???'} x ${pkg.widthCm || '???'} x ${
                        pkg.heightCm || '???'
                      } cm)`}</div>
                    )}
                  </div>
                  <div className="package_quantity">
                    {pkg.quantity} {pkg.job?.packageType?.shortName || 'pkg'}
                    {pkg.quantity > 1 ? 's' : ''}
                  </div>
                  <div className="package_weight">{pkg.grossWeightKg || '???'} kg</div>
                  <div className="package_volume">{pkg.cubicMetres || '0.00'} m³</div>
                  {assignedPackages && !completed && (
                    <div className="load_button_container">
                      <button className={`load_button`} onClick={() => assignPackage(pkg.id)}>
                        Load
                      </button>
                    </div>
                  )}
                </div>
                <ul className="dangerous_goods_details">
                  {pkg.dangerousGoodsAssociations?.length > 0 ? (
                    pkg.dangerousGoodsAssociations?.map(dangerousGood => (
                      <li key={dangerousGood.id}>
                        {
                          dangerousGoods?.find(
                            good => good.id == dangerousGood.dangerousGoodsLineItemId,
                          )?.longText
                        }
                      </li>
                    ))
                  ) : (
                    <li>No Dangerous Goods present</li>
                  )}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
      {outstandingCollections?.length > 0 && (
        <div className="packages_in_warehouse_container">
          <div className="packages_in_warehouse_title">Outstanding Collections</div>
          <div className="packages_in_warehouse_body">
            {outstandingCollections?.map(collection => {
              const expQuantity = collection?.assignments
                ?.map(a => a?.quantity)
                .reduce((a, b) => a + b, 0);
              const expWeight = collection?.assignments
                ?.map(a => a?.grossWeightKg)
                .reduce((a, b) => a + b, 0);
              const expVolume = Number(
                collection.assignments?.map(a => a?.cubicMetres).reduce((a, b) => a + b, 0),
              ).toFixed(2);
              return (
                <div className="package" key={collection.id}>
                  <div className="package_details pending">
                    <div className="col-1">
                      <div className="package_ref">{collection?.supplier?.name}</div>
                      <div className="package_creation_method">Pending</div>
                    </div>
                    <div className="package_quantity">{expQuantity} pkg</div>
                    <div className="package_weight">{expWeight} kg</div>
                    <div className="package_volume">{expVolume} m³</div>
                    {!completed && (
                      <div className="load_button_container">
                        <button
                          className={`load_button orange`}
                          onClick={() => setModalOpen('transship')}
                        >
                          Load
                        </button>
                      </div>
                    )}
                  </div>
                  <ul className="dangerous_goods_details">
                    {job?.cargoHazardous ? (
                      dangerousGoods?.map(dangerousGood => (
                        <li key={dangerousGood.id}>{dangerousGood?.longText}</li>
                      ))
                    ) : (
                      <li>No Dangerous Goods present</li>
                    )}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {modalOpen && (
        <Modal title={getModalTitle()} content={getModalType()} setModalOpen={setModalOpen} />
      )}
    </>
  );
};

AssociatedPackageList.propTypes = {
  job: PropTypes.object,
  hubId: PropTypes.number,
  bays: PropTypes.array,
  racks: PropTypes.object,
  setError: PropTypes.func,
  setLoading: PropTypes.func,
  category: PropTypes.string,
  movementType: PropTypes.string,
  movement: PropTypes.object,
  assignedPackages: PropTypes.array,
  refreshPackages: PropTypes.func,
  setDisplayAssignment: PropTypes.func,
  completed: PropTypes.bool,
};

export default AssociatedPackageList;
